<div [formGroup]="parentForm">
  <div [formGroupName]="authControlKey">
    <div fxLayout="row wrap" fxLayoutGap="20px grid">
      <div fxFlex="100">
        <mat-card class="u-margin-bottom-15">
          <mat-card-header>
            <mat-card-title
              >{{ "organization.module_assignment_tab.bigcommerce.authentication_details" |
              translate }}</mat-card-title
            >
          </mat-card-header>
          <mat-card-content>
            <div fxFlex="100">
              <div fxLayout="row wrap" fxLayoutGap="20px grid">
                <div fxFlex="50">
                  <mat-form-field class="mat-block">
                    <input
                      formControlName="ebasketBigCommerceAccessToken"
                      id="ebasketBigCommerceAccessToken"
                      matInput
                      required
                      [placeholder]="
                    'organization.module_assignment_tab.bigcommerce.access_token' |
                    translate"
                    />
                  </mat-form-field>
                </div>
                <div fxFlex="50">
                  <mat-form-field class="mat-block">
                    <input
                      formControlName="ebasketBigCommerceStoreHash"
                      id="ebasketBigCommerceStoreHash"
                      matInput
                      required
                      [placeholder]="
                    'organization.module_assignment_tab.bigcommerce.Store_hash' |
                    translate"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <div fxLayout="row wrap" fxLayoutGap="20px grid">
      <div fxFlex="100">
        <mat-card class="u-margin-bottom-15">
          <mat-card-header>
            <div fxFlex="20" class="u-text-left">
              <mat-card-title>{{ "magento.api_details" | translate }}</mat-card-title>
            </div>
            <div fxFlex="80" class="u-text-right">
              <button
                [disabled]="action=='view' || isEBasketBigcommerceAddDisabled"
                mat-flat-button
                color="primary"
                (click)="openEbasketBigCommerceSelectApiPopup();"
              >
                {{ 'magento.add' | translate}}
              </button>
            </div>
          </mat-card-header>
          <mat-card-content
            *ngFor="let apiDetails of parentForm.get(authControlKey).get('ebasketBigCommerceApiDetails')['controls']; let i = index"
            formArrayName="ebasketBigCommerceApiDetails"
          >
            <div [formGroupName]="i">
              <div fxFlex="80">
                <mat-accordion>
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        {{ apiDetails.value.selectedApi}}
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div fxLayout="row wrap" fxLayoutGap="20px grid">
                      <div [fxFlex]="inventory?100:50">
                        <mat-form-field class="mat-block">
                          <input
                            id="ebasketURL"
                            formControlName="url"
                            matInput
                            required
                            [placeholder]="
                    'organization.module_assignment_tab.bigcommerce.url' |
                    translate"
                          />
                        </mat-form-field>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
              <div fxFlex="20" class="u-text-right">
                <button
                  [disabled]="action=='view'"
                  mat-flat-button
                  color="primary"
                  (click)="deleteEbasketInventoryApiDetailContainer(i);"
                >
                  {{ 'magento.delete' | translate}}
                </button>
              </div>
            </div>
          </mat-card-content>

          <div
            *ngFor="let apiDetails of parentForm.get(authControlKey).get('ebasketBigCommerceApiDetails')['controls']; let i = index"
          >
            <mat-error *ngIf="( (action !== 'view') && (!apiDetails.value.url))">
              {{
              "organization.module_assignment_tab.bigcommerce.api_and_authentication_details_required"
              | translate }}
            </mat-error>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
</div>
